var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUsHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6653",
    d: "M128.963 39.876C128.854 17.958 110.916 0 88.901 0S48.948 17.958 48.948 39.985l.108 8.045H40.91C18.9 48.03.963 65.987.963 88.008s17.938 39.986 39.953 39.986h71.369c9.209 0 16.671-7.469 16.671-16.684V39.876z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F82",
    d: "M128.963 97.902v-58.02C128.854 17.965 110.916.007 88.901.007S48.948 17.964 48.948 39.992l.108 8.044c18.361 3.789 32.165 20.063 32.165 39.563 0 2.528-.237 4.992-.672 7.385l-.05.282a27 27 0 0 0-.532 5.388c0 15.103 12.223 27.333 27.314 27.346h5.011c9.209 0 16.671-7.468 16.671-16.684V97.902"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsHeart);
export default __webpack_public_path__ + "static/media/ContactUsHeart.04e4cffdcbe678c4bcccbf93ce5b1890.svg";
export { ForwardRef as ReactComponent };